import ProgressNoteTemplates from './progress-note-templates'
export default ProgressNoteTemplates
